import importSheet, { importRDO } from '../api/importSheet'
import saveModel from '../api/saveModel'
import globalNotification from 'live/services/global-notification'

export default function pushData(sheetIndex, eventType, keys, fileName) {
    return (dispatch, getState) => {
        const uid = getState().sheet.uid

        importSheet(uid, sheetIndex, eventType, keys, fileName)
            .then(r => {
                const reader = r.body.getReader()
                reader.read().then(function getText({ done, value }) {
                    if (done) {
                        dispatch({ type: 'SHEET_IMPORTED' })
                        return
                    }

                    const text = new TextDecoder('utf-8').decode(value)
                    if (text.startsWith('Error - ')) {
                        dispatch({ type: 'SHEET_IMPORT_ERROR', errorMessage: text.slice(8) })
                        return
                    }

                    dispatch({ type: 'SHEET_IMPORTING' })
                    return reader.read().then(getText)
                })
            })
            .catch(err => {
                err.response.json().then(({ error }) => {
                    console.error('Error importing data:', error)
                    dispatch({
                        type: 'SHEET_IMPORT_ERROR',
                        errorMessage: error
                    })
                })
            })
    }
}

export function pushDataRDO(sheetIndex, eventType, keys, fileName) {

    return (dispatch, getState) => {
        const uid = getState().sheet.uid

        importRDO(uid, sheetIndex, eventType, keys, fileName)
            .then(r => {
                const reader = r.body.getReader()
                reader.read().then(function getText({ done, value }) {
                    if (done) {
                        dispatch({ type: 'SHEET_IMPORTED' })
                        return
                    }

                    const text = new TextDecoder('utf-8').decode(value)

                    console.log(text)
                    
                    if (text.startsWith('Error - ')) {
                        dispatch({ type: 'SHEET_IMPORT_ERROR', errorMessage: text.slice(8) })
                        return
                    }

                    dispatch({ type: 'SHEET_IMPORTING' })
                    return reader.read().then(getText)
                })
            })
            .catch(err => {
                err.response.json().then(({ error }) => {
                    console.error('Error importing data:', error)
                    dispatch({
                        type: 'SHEET_IMPORT_ERROR',
                        errorMessage: error
                    })
                })
            })
    }
}

export function pushDataModel(sheetIndex, eventType, keys, perspective, databaseName, dateReference,skipRealtime) {
    
    return (dispatch, getState) => {
        const { selected, sheetData, uid } = getState().sheet
        const header = sheetData[selected].header
        dispatch({ type: 'SHEET_STARTING_SAVE_MODEL' })
        setImmediate(
            () =>
                saveModel(uid, sheetIndex, eventType, keys, header, perspective, databaseName, dateReference,skipRealtime)
                    .then(r => {
                        globalNotification.success(`Model successfully saved: ${eventType}.`)
                        dispatch({ type: 'SHEET_SAVE_MODEL', model: { name: eventType, perspective: perspective, databaseName: databaseName } })                        
                    })
                    .catch( async ({response})  => {
                        const responseError = await response.json()
                        const msg = responseError?.error  || `Error: ${response.status}`

                        dispatch({
                            type: 'SHEET_SAVE_MODEL_ERROR',
                            error: { status: response.status, msg }
                        })
                    }),
            100
        )
    }
}
